import { render } from "./ProductPreviewPage.vue?vue&type=template&id=2c5aa4d6&scoped=true"
import script from "./ProductPreviewPage.vue?vue&type=script&lang=js"
export * from "./ProductPreviewPage.vue?vue&type=script&lang=js"

import "./ProductPreviewPage.vue?vue&type=style&index=0&id=2c5aa4d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c5aa4d6"]])

export default __exports__